export function base64ToUtf8(base64: string): string {
    const binary = window.atob(base64);
    const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
    return new TextDecoder('utf-8').decode(bytes);
}